module.exports = __webpack_public_path__ + "media/newstyle/images/50-countries-es-99cb6b2e065cbd1a19ef87d34a75f0da.svg";